import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { ReplacementDataMediumSourcesActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.ReplacementDataMediumSource };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSource,
    ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSources,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(
    ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSourceSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false
      };
    }
  ),
  on(
    ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSourcesSuccess,
    (state, { response }) => {
      const fss = response['hydra:member'];
      const entities = fss.reduce(
        (
          entities: {
            [id: string]: fromModuleModels.ReplacementDataMediumSource;
          },
          fs
        ) => {
          return {
            ...entities,
            [fs['@id']]: fs
          };
        },
        { ...state.entities }
      );

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(
    ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSourceFail,
    ReplacementDataMediumSourcesActions.ReadReplacementDataMediumSourcesFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
